import { Layout } from '@denqfabrik/landing-ui';
import type { ReactNode } from 'react';
import SeoHead from '@/components/SeoHead';
import Footer from './Footer';
import Navbar from './Navbar';

export default function AppLayout({ children }: { children: ReactNode }) {
  return (
    <Layout navbar={<Navbar />} footer={<Footer />} seoHead={<SeoHead />}>
      {children}
    </Layout>
  );
}
